<template>
  <section class="main-content">
    <MainBanner banner="Error" />
    <section class="block-content ">
        <div class="container my-5 py-5">
            <div class="content-midwide text-center" data-aos="fade-up" data-aos-duration="1000" data-aos-offset="100">
                <p>
                <router-link :to="{name: 'home'}" class="btn btn-outline-ito hover-red animated-arrow mt-3">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"></path></svg>
                    Zur Starseite springen
                </router-link>
            </p>
            </div>
        </div>
    </section>
  </section>
</template>

<script>

import store from '@/store'
const MainBanner = () => import('@/components/Content/MainBanner.vue')

export default {
  name: 'PageNotFound',
  metaInfo () {
    return {
      title: 'Seite nicht gefunden - ito consult GmbH'
    }
  },
  data: function () {
    return {
    }
  },
  components: {
    MainBanner
  },
  mounted () {
    store.commit('loadingStatus', false)
  }
}
</script>
